/* tslint:disable */
/* eslint-disable */
/**
 * Filtered Endpoints for BCISA sites
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface AWUPerson
 */
export interface AWUPerson {
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'id'?: string;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'vorname'?: string;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'nachname'?: string;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'titelVorangestellt'?: string;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'titelNachgestellt'?: string;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'geschlecht'?: string;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'oe'?: string;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'oeName'?: string;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'mobil'?: string;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'kurzwahl'?: string;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'email'?: string;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'eintritt'?: string;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof AWUPerson
     */
    'fuehrungskraft'?: { [key: string]: string; };
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'fotoHash'?: string;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'foto'?: string;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'raum'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof AWUPerson
     */
    'tabs'?: Array<string>;
    /**
     *
     * @type {boolean}
     * @memberof AWUPerson
     */
    'extern'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AWUPerson
     */
    'sicherheitsvertrauensperson'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AWUPerson
     */
    'brandschutz'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AWUPerson
     */
    'ersthelfer'?: boolean;
    /**
     *
     * @type {string}
     * @memberof AWUPerson
     */
    'telefon'?: string;
}
/**
 *
 * @export
 * @interface Anwendung
 */
export interface Anwendung {
    /**
     *
     * @type {string}
     * @memberof Anwendung
     */
    'id'?: string;
    /**
     *
     * @type {string}
     * @memberof Anwendung
     */
    'displayName'?: string;
    /**
     *
     * @type {string}
     * @memberof Anwendung
     */
    'uri'?: string;
    /**
     *
     * @type {boolean}
     * @memberof Anwendung
     */
    'favorit'?: boolean;
    /**
     *
     * @type {string}
     * @memberof Anwendung
     */
    'tooltip'?: string;
    /**
     *
     * @type {AnwendungWindowSettings}
     * @memberof Anwendung
     */
    'window'?: AnwendungWindowSettings;
}
/**
 *
 * @export
 * @interface AnwendungWindowSettings
 */
export interface AnwendungWindowSettings {
    /**
     *
     * @type {number}
     * @memberof AnwendungWindowSettings
     */
    'screenWidth'?: number;
    /**
     *
     * @type {number}
     * @memberof AnwendungWindowSettings
     */
    'screenHeight'?: number;
    /**
     *
     * @type {number}
     * @memberof AnwendungWindowSettings
     */
    'left'?: number;
    /**
     *
     * @type {number}
     * @memberof AnwendungWindowSettings
     */
    'top'?: number;
    /**
     *
     * @type {boolean}
     * @memberof AnwendungWindowSettings
     */
    'location'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AnwendungWindowSettings
     */
    'menubar'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AnwendungWindowSettings
     */
    'resizable'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AnwendungWindowSettings
     */
    'toolbar'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AnwendungWindowSettings
     */
    'scrollbars'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AnwendungWindowSettings
     */
    'status'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AnwendungWindowSettings
     */
    'dependent'?: boolean;
    /**
     *
     * @type {number}
     * @memberof AnwendungWindowSettings
     */
    'blurfunction'?: number;
}
/**
 *
 * @export
 * @interface AnwendungDTO
 */
export interface AnwendungDTO {
    /**
     *
     * @type {string}
     * @memberof AnwendungDTO
     */
    'id': string;
    /**
     *
     * @type {boolean}
     * @memberof AnwendungDTO
     */
    'favorit'?: boolean;
}
/**
 *
 * @export
 * @interface Betriebsmeldung
 */
export interface Betriebsmeldung {
    /**
     *
     * @type {number}
     * @memberof Betriebsmeldung
     */
    'uid'?: number;
    /**
     *
     * @type {string}
     * @memberof Betriebsmeldung
     */
    'title'?: string;
    /**
     *
     * @type {string}
     * @memberof Betriebsmeldung
     */
    'text'?: string;
    /**
     *
     * @type {string}
     * @memberof Betriebsmeldung
     */
    'startEventDate'?: string;
    /**
     *
     * @type {string}
     * @memberof Betriebsmeldung
     */
    'endEventDate'?: string;
    /**
     *
     * @type {string}
     * @memberof Betriebsmeldung
     */
    'startDateTime'?: string;
    /**
     *
     * @type {string}
     * @memberof Betriebsmeldung
     */
    'endDateTime'?: string;
    /**
     *
     * @type {boolean}
     * @memberof Betriebsmeldung
     */
    'active'?: boolean;
    /**
     *
     * @type {BetriebsmeldungFlag}
     * @memberof Betriebsmeldung
     */
    'type'?: BetriebsmeldungFlag;
    /**
     *
     * @type {Array<BetriebsmeldungFlag>}
     * @memberof Betriebsmeldung
     */
    'visibilities'?: Array<BetriebsmeldungFlag>;
    /**
     *
     * @type {Array<BetriebsmeldungPortal>}
     * @memberof Betriebsmeldung
     */
    'portals'?: Array<BetriebsmeldungPortal>;
    /**
     *
     * @type {string}
     * @memberof Betriebsmeldung
     */
    'departments'?: string;
    /**
     *
     * @type {string}
     * @memberof Betriebsmeldung
     */
    'applications'?: string;
    /**
     *
     * @type {Array<BetriebsmeldungDocument>}
     * @memberof Betriebsmeldung
     */
    'documents'?: Array<BetriebsmeldungDocument>;
    /**
     *
     * @type {string}
     * @memberof Betriebsmeldung
     */
    'created'?: string;
    /**
     *
     * @type {string}
     * @memberof Betriebsmeldung
     */
    'createdFrom'?: string;
    /**
     *
     * @type {string}
     * @memberof Betriebsmeldung
     */
    'modified'?: string;
    /**
     *
     * @type {string}
     * @memberof Betriebsmeldung
     */
    'modifiedFrom'?: string;
    /**
     *
     * @type {number}
     * @memberof Betriebsmeldung
     */
    'usedDocumentCount'?: number;
    /**
     *
     * @type {number}
     * @memberof Betriebsmeldung
     */
    'freeDocumentCount'?: number;
    /**
     *
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof Betriebsmeldung
     */
    'get_links'?: { [key: string]: { [key: string]: string; }; };
}
/**
 *
 * @export
 * @interface BetriebsmeldungDocument
 */
export interface BetriebsmeldungDocument {
    /**
     *
     * @type {number}
     * @memberof BetriebsmeldungDocument
     */
    'uid'?: number;
    /**
     *
     * @type {string}
     * @memberof BetriebsmeldungDocument
     */
    'content'?: string;
    /**
     *
     * @type {string}
     * @memberof BetriebsmeldungDocument
     */
    'contentType'?: string;
    /**
     *
     * @type {string}
     * @memberof BetriebsmeldungDocument
     */
    'name'?: string;
    /**
     *
     * @type {number}
     * @memberof BetriebsmeldungDocument
     */
    'size'?: number;
    /**
     *
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof BetriebsmeldungDocument
     */
    'get_links'?: { [key: string]: { [key: string]: string; }; };
}
/**
 *
 * @export
 * @interface BetriebsmeldungFlag
 */
export interface BetriebsmeldungFlag {
    /**
     *
     * @type {number}
     * @memberof BetriebsmeldungFlag
     */
    'uid'?: number;
    /**
     *
     * @type {string}
     * @memberof BetriebsmeldungFlag
     */
    'name'?: string;
    /**
     *
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof BetriebsmeldungFlag
     */
    'get_links'?: { [key: string]: { [key: string]: string; }; };
}
/**
 *
 * @export
 * @interface BetriebsmeldungPortal
 */
export interface BetriebsmeldungPortal {
    /**
     *
     * @type {number}
     * @memberof BetriebsmeldungPortal
     */
    'uid'?: number;
    /**
     *
     * @type {string}
     * @memberof BetriebsmeldungPortal
     */
    'code'?: string;
    /**
     *
     * @type {string}
     * @memberof BetriebsmeldungPortal
     */
    'name'?: string;
    /**
     *
     * @type {boolean}
     * @memberof BetriebsmeldungPortal
     */
    'adminApproval'?: boolean;
    /**
     *
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof BetriebsmeldungPortal
     */
    'get_links'?: { [key: string]: { [key: string]: string; }; };
}
/**
 *
 * @export
 * @interface BundleLikes
 */
export interface BundleLikes {
    /**
     *
     * @type {string}
     * @memberof BundleLikes
     */
    'bundleId'?: string;
    /**
     *
     * @type {Array<ContentLikes>}
     * @memberof BundleLikes
     */
    'bundleLikes'?: Array<ContentLikes>;
}
/**
 *
 * @export
 * @interface Comment
 */
export interface Comment {
    /**
     *
     * @type {string}
     * @memberof Comment
     */
    'id'?: string;
    /**
     *
     * @type {string}
     * @memberof Comment
     */
    'timestamp'?: string;
    /**
     *
     * @type {string}
     * @memberof Comment
     */
    'threadid'?: string;
    /**
     *
     * @type {string}
     * @memberof Comment
     */
    'parentid'?: string;
    /**
     *
     * @type {string}
     * @memberof Comment
     */
    'userid'?: string;
    /**
     *
     * @type {string}
     * @memberof Comment
     */
    'username'?: string;
    /**
     *
     * @type {string}
     * @memberof Comment
     */
    'title'?: string;
    /**
     *
     * @type {string}
     * @memberof Comment
     */
    'body'?: string;
    /**
     *
     * @type {boolean}
     * @memberof Comment
     */
    'deleted'?: boolean;
    /**
     *
     * @type {Comment[]Comment[]}
     * @memberof Comment
     */
    'replies'?: Comment[];
}
/**
 *
 * @export
 * @interface CommentDTO
 */
export interface CommentDTO {
    /**
     *
     * @type {string}
     * @memberof CommentDTO
     */
    'parentid'?: string;
    /**
     *
     * @type {string}
     * @memberof CommentDTO
     */
    'title'?: string;
    /**
     *
     * @type {string}
     * @memberof CommentDTO
     */
    'body': string;
}
/**
 *
 * @export
 * @interface CommentThread
 */
export interface CommentThread {
    /**
     *
     * @type {string}
     * @memberof CommentThread
     */
    'id'?: string;
    /**
     *
     * @type {string}
     * @memberof CommentThread
     */
    'topic'?: string;
    /**
     *
     * @type {Array<Comment>}
     * @memberof CommentThread
     */
    'comments'?: Array<Comment>;
    /**
     *
     * @type {number}
     * @memberof CommentThread
     */
    'totalComments'?: number;
    /**
     *
     * @type {string}
     * @memberof CommentThread
     */
    'lastUpdate'?: string;
}
/**
 *
 * @export
 * @interface ContentLikes
 */
export interface ContentLikes {
    /**
     *
     * @type {string}
     * @memberof ContentLikes
     */
    'contentId'?: string;
    /**
     *
     * @type {string}
     * @memberof ContentLikes
     */
    'category'?: string;
    /**
     *
     * @type {number}
     * @memberof ContentLikes
     */
    'likes'?: number;
}
/**
 *
 * @export
 * @interface LikeEvent
 */
export interface LikeEvent {
    /**
     *
     * @type {ObjectId}
     * @memberof LikeEvent
     */
    'id'?: ObjectId;
    /**
     *
     * @type {string}
     * @memberof LikeEvent
     */
    'timestamp'?: string;
    /**
     *
     * @type {string}
     * @memberof LikeEvent
     */
    'userid'?: string;
    /**
     *
     * @type {string}
     * @memberof LikeEvent
     */
    'contentid'?: string;
    /**
     *
     * @type {string}
     * @memberof LikeEvent
     */
    'category'?: string;
    /**
     *
     * @type {string}
     * @memberof LikeEvent
     */
    'bundleid'?: string;
}
/**
 *
 * @export
 * @interface MeDTO
 */
export interface MeDTO {
    /**
     *
     * @type {string}
     * @memberof MeDTO
     */
    'username'?: string;
    /**
     *
     * @type {string}
     * @memberof MeDTO
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof MeDTO
     */
    'email'?: string;
}
/**
 *
 * @export
 * @interface ObjectId
 */
export interface ObjectId {
    /**
     *
     * @type {number}
     * @memberof ObjectId
     */
    'timestamp'?: number;
    /**
     *
     * @type {string}
     * @memberof ObjectId
     */
    'date'?: string;
}

/**
 * AWUAPIApi - axios parameter creator
 * @export
 */
export const AWUAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/awu/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AWUAPIApi - functional programming interface
 * @export
 */
export const AWUAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AWUAPIApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async me(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AWUPerson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.me(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AWUAPIApi - factory interface
 * @export
 */
export const AWUAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AWUAPIApiFp(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me(options?: any): AxiosPromise<AWUPerson> {
            return localVarFp.me(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AWUAPIApi - object-oriented interface
 * @export
 * @class AWUAPIApi
 * @extends {BaseAPI}
 */
export class AWUAPIApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AWUAPIApi
     */
    public me(options?: AxiosRequestConfig) {
        return AWUAPIApiFp(this.configuration).me(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AnwendungslisteAPIApi - axios parameter creator
 * @export
 */
export const AnwendungslisteAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Anwendung aus Favoriten entfernen
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritLoeschen: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('favoritLoeschen', 'id', id)
            const localVarPath = `/anwendungsliste/favoriten/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Anwendung zu Favoriten hinzufuegen
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritSetzen: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('favoritSetzen', 'id', id)
            const localVarPath = `/anwendungsliste/favoriten/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reihenfolge wird wie im uebergebenen Array, bisherigen Favoriten werden ueberschrieben.
         * @summary Favoriten und Reihenfolge setzen
         * @param {Array<AnwendungDTO>} [anwendungDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritenReihenfolge: async (anwendungDTO?: Array<AnwendungDTO>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/anwendungsliste/favoriten`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(anwendungDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Alle Anwendungen des Benutzers vom Portal laden. Diese Daten werden in der Magnolia Session des Benutzers gecached.
         * @summary Alle anwendungen laden
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meineAnwendungen: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/anwendungsliste/alle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Anwendungsfavouriten des Benutzers laden.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meineFavoriten: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/anwendungsliste/favoriten`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnwendungslisteAPIApi - functional programming interface
 * @export
 */
export const AnwendungslisteAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnwendungslisteAPIApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Anwendung aus Favoriten entfernen
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoritLoeschen(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoritLoeschen(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Anwendung zu Favoriten hinzufuegen
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoritSetzen(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoritSetzen(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reihenfolge wird wie im uebergebenen Array, bisherigen Favoriten werden ueberschrieben.
         * @summary Favoriten und Reihenfolge setzen
         * @param {Array<AnwendungDTO>} [anwendungDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoritenReihenfolge(anwendungDTO?: Array<AnwendungDTO>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoritenReihenfolge(anwendungDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Alle Anwendungen des Benutzers vom Portal laden. Diese Daten werden in der Magnolia Session des Benutzers gecached.
         * @summary Alle anwendungen laden
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async meineAnwendungen(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Anwendung>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.meineAnwendungen(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Anwendungsfavouriten des Benutzers laden.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async meineFavoriten(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Anwendung>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.meineFavoriten(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnwendungslisteAPIApi - factory interface
 * @export
 */
export const AnwendungslisteAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnwendungslisteAPIApiFp(configuration)
    return {
        /**
         *
         * @summary Anwendung aus Favoriten entfernen
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritLoeschen(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.favoritLoeschen(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Anwendung zu Favoriten hinzufuegen
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritSetzen(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.favoritSetzen(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Reihenfolge wird wie im uebergebenen Array, bisherigen Favoriten werden ueberschrieben.
         * @summary Favoriten und Reihenfolge setzen
         * @param {Array<AnwendungDTO>} [anwendungDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritenReihenfolge(anwendungDTO?: Array<AnwendungDTO>, options?: any): AxiosPromise<void> {
            return localVarFp.favoritenReihenfolge(anwendungDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Alle Anwendungen des Benutzers vom Portal laden. Diese Daten werden in der Magnolia Session des Benutzers gecached.
         * @summary Alle anwendungen laden
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meineAnwendungen(options?: any): AxiosPromise<Array<Anwendung>> {
            return localVarFp.meineAnwendungen(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Anwendungsfavouriten des Benutzers laden.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meineFavoriten(options?: any): AxiosPromise<Array<Anwendung>> {
            return localVarFp.meineFavoriten(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnwendungslisteAPIApi - object-oriented interface
 * @export
 * @class AnwendungslisteAPIApi
 * @extends {BaseAPI}
 */
export class AnwendungslisteAPIApi extends BaseAPI {
    /**
     *
     * @summary Anwendung aus Favoriten entfernen
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnwendungslisteAPIApi
     */
    public favoritLoeschen(id: string, options?: AxiosRequestConfig) {
        return AnwendungslisteAPIApiFp(this.configuration).favoritLoeschen(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Anwendung zu Favoriten hinzufuegen
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnwendungslisteAPIApi
     */
    public favoritSetzen(id: string, options?: AxiosRequestConfig) {
        return AnwendungslisteAPIApiFp(this.configuration).favoritSetzen(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reihenfolge wird wie im uebergebenen Array, bisherigen Favoriten werden ueberschrieben.
     * @summary Favoriten und Reihenfolge setzen
     * @param {Array<AnwendungDTO>} [anwendungDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnwendungslisteAPIApi
     */
    public favoritenReihenfolge(anwendungDTO?: Array<AnwendungDTO>, options?: AxiosRequestConfig) {
        return AnwendungslisteAPIApiFp(this.configuration).favoritenReihenfolge(anwendungDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Alle Anwendungen des Benutzers vom Portal laden. Diese Daten werden in der Magnolia Session des Benutzers gecached.
     * @summary Alle anwendungen laden
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnwendungslisteAPIApi
     */
    public meineAnwendungen(options?: AxiosRequestConfig) {
        return AnwendungslisteAPIApiFp(this.configuration).meineAnwendungen(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Anwendungsfavouriten des Benutzers laden.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnwendungslisteAPIApi
     */
    public meineFavoriten(options?: AxiosRequestConfig) {
        return AnwendungslisteAPIApiFp(this.configuration).meineFavoriten(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BMBCommentsAPIApi - axios parameter creator
 * @export
 */
export const BMBCommentsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} threadid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsByThread: async (threadid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadid' is not null or undefined
            assertParamExists('commentsByThread', 'threadid', threadid)
            const localVarPath = `/bmb/v1/comments/{threadid}`
                .replace(`{${"threadid"}}`, encodeURIComponent(String(threadid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} threadid
         * @param {string} commentid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment: async (threadid: string, commentid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadid' is not null or undefined
            assertParamExists('deleteComment', 'threadid', threadid)
            // verify required parameter 'commentid' is not null or undefined
            assertParamExists('deleteComment', 'commentid', commentid)
            const localVarPath = `/bmb/v1/comments/{threadid}/{commentid}`
                .replace(`{${"threadid"}}`, encodeURIComponent(String(threadid)))
                .replace(`{${"commentid"}}`, encodeURIComponent(String(commentid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} threadid
         * @param {CommentDTO} [commentDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitComment: async (threadid: string, commentDTO?: CommentDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadid' is not null or undefined
            assertParamExists('submitComment', 'threadid', threadid)
            const localVarPath = `/bmb/v1/comments/{threadid}`
                .replace(`{${"threadid"}}`, encodeURIComponent(String(threadid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} threadid
         * @param {string} commentid
         * @param {CommentDTO} [commentDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComment: async (threadid: string, commentid: string, commentDTO?: CommentDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadid' is not null or undefined
            assertParamExists('updateComment', 'threadid', threadid)
            // verify required parameter 'commentid' is not null or undefined
            assertParamExists('updateComment', 'commentid', commentid)
            const localVarPath = `/bmb/v1/comments/{threadid}/{commentid}`
                .replace(`{${"threadid"}}`, encodeURIComponent(String(threadid)))
                .replace(`{${"commentid"}}`, encodeURIComponent(String(commentid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BMBCommentsAPIApi - functional programming interface
 * @export
 */
export const BMBCommentsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BMBCommentsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {string} threadid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsByThread(threadid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsByThread(threadid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} threadid
         * @param {string} commentid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComment(threadid: string, commentid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComment(threadid, commentid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} threadid
         * @param {CommentDTO} [commentDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitComment(threadid: string, commentDTO?: CommentDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitComment(threadid, commentDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} threadid
         * @param {string} commentid
         * @param {CommentDTO} [commentDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateComment(threadid: string, commentid: string, commentDTO?: CommentDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateComment(threadid, commentid, commentDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BMBCommentsAPIApi - factory interface
 * @export
 */
export const BMBCommentsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BMBCommentsAPIApiFp(configuration)
    return {
        /**
         *
         * @param {string} threadid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsByThread(threadid: string, options?: any): AxiosPromise<CommentThread> {
            return localVarFp.commentsByThread(threadid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} threadid
         * @param {string} commentid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment(threadid: string, commentid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteComment(threadid, commentid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} threadid
         * @param {CommentDTO} [commentDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitComment(threadid: string, commentDTO?: CommentDTO, options?: any): AxiosPromise<void> {
            return localVarFp.submitComment(threadid, commentDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} threadid
         * @param {string} commentid
         * @param {CommentDTO} [commentDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComment(threadid: string, commentid: string, commentDTO?: CommentDTO, options?: any): AxiosPromise<void> {
            return localVarFp.updateComment(threadid, commentid, commentDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BMBCommentsAPIApi - object-oriented interface
 * @export
 * @class BMBCommentsAPIApi
 * @extends {BaseAPI}
 */
export class BMBCommentsAPIApi extends BaseAPI {
    /**
     *
     * @param {string} threadid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BMBCommentsAPIApi
     */
    public commentsByThread(threadid: string, options?: AxiosRequestConfig) {
        return BMBCommentsAPIApiFp(this.configuration).commentsByThread(threadid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} threadid
     * @param {string} commentid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BMBCommentsAPIApi
     */
    public deleteComment(threadid: string, commentid: string, options?: AxiosRequestConfig) {
        return BMBCommentsAPIApiFp(this.configuration).deleteComment(threadid, commentid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} threadid
     * @param {CommentDTO} [commentDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BMBCommentsAPIApi
     */
    public submitComment(threadid: string, commentDTO?: CommentDTO, options?: AxiosRequestConfig) {
        return BMBCommentsAPIApiFp(this.configuration).submitComment(threadid, commentDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} threadid
     * @param {string} commentid
     * @param {CommentDTO} [commentDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BMBCommentsAPIApi
     */
    public updateComment(threadid: string, commentid: string, commentDTO?: CommentDTO, options?: AxiosRequestConfig) {
        return BMBCommentsAPIApiFp(this.configuration).updateComment(threadid, commentid, commentDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BMBLikeAPIApi - axios parameter creator
 * @export
 */
export const BMBLikeAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Like the given content for the current user
         * @param {string} id ID of the content liked
         * @param {string} cat Like category
         * @param {string} [bundle] Optional bundle ID for the content liked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        like: async (id: string, cat: string, bundle?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('like', 'id', id)
            // verify required parameter 'cat' is not null or undefined
            assertParamExists('like', 'cat', cat)
            const localVarPath = `/bmb/v1/likes/{cat}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"cat"}}`, encodeURIComponent(String(cat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bundle !== undefined) {
                localVarQueryParameter['bundle'] = bundle;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all all the likes belonging to the given bundle
         * @param {string} bundle Bundle ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likesByBundle: async (bundle: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bundle' is not null or undefined
            assertParamExists('likesByBundle', 'bundle', bundle)
            const localVarPath = `/bmb/v1/likes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bundle !== undefined) {
                localVarQueryParameter['bundle'] = bundle;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the likes of a given content
         * @param {string} id ID of the content
         * @param {string} cat Like category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likesByContent: async (id: string, cat: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('likesByContent', 'id', id)
            // verify required parameter 'cat' is not null or undefined
            assertParamExists('likesByContent', 'cat', cat)
            const localVarPath = `/bmb/v1/likes/{cat}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"cat"}}`, encodeURIComponent(String(cat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the current user\'s likes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myLikes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bmb/v1/likes/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unlike the given content for the current user
         * @param {string} id ID of the content unliked
         * @param {string} cat Like category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlike: async (id: string, cat: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unlike', 'id', id)
            // verify required parameter 'cat' is not null or undefined
            assertParamExists('unlike', 'cat', cat)
            const localVarPath = `/bmb/v1/likes/{cat}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"cat"}}`, encodeURIComponent(String(cat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BMBLikeAPIApi - functional programming interface
 * @export
 */
export const BMBLikeAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BMBLikeAPIApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Like the given content for the current user
         * @param {string} id ID of the content liked
         * @param {string} cat Like category
         * @param {string} [bundle] Optional bundle ID for the content liked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async like(id: string, cat: string, bundle?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.like(id, cat, bundle, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all all the likes belonging to the given bundle
         * @param {string} bundle Bundle ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async likesByBundle(bundle: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleLikes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.likesByBundle(bundle, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get the likes of a given content
         * @param {string} id ID of the content
         * @param {string} cat Like category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async likesByContent(id: string, cat: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentLikes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.likesByContent(id, cat, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get the current user\'s likes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myLikes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LikeEvent>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myLikes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Unlike the given content for the current user
         * @param {string} id ID of the content unliked
         * @param {string} cat Like category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlike(id: string, cat: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlike(id, cat, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BMBLikeAPIApi - factory interface
 * @export
 */
export const BMBLikeAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BMBLikeAPIApiFp(configuration)
    return {
        /**
         *
         * @summary Like the given content for the current user
         * @param {string} id ID of the content liked
         * @param {string} cat Like category
         * @param {string} [bundle] Optional bundle ID for the content liked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        like(id: string, cat: string, bundle?: string, options?: any): AxiosPromise<void> {
            return localVarFp.like(id, cat, bundle, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all all the likes belonging to the given bundle
         * @param {string} bundle Bundle ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likesByBundle(bundle: string, options?: any): AxiosPromise<BundleLikes> {
            return localVarFp.likesByBundle(bundle, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the likes of a given content
         * @param {string} id ID of the content
         * @param {string} cat Like category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likesByContent(id: string, cat: string, options?: any): AxiosPromise<ContentLikes> {
            return localVarFp.likesByContent(id, cat, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the current user\'s likes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myLikes(options?: any): AxiosPromise<Array<LikeEvent>> {
            return localVarFp.myLikes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unlike the given content for the current user
         * @param {string} id ID of the content unliked
         * @param {string} cat Like category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlike(id: string, cat: string, options?: any): AxiosPromise<void> {
            return localVarFp.unlike(id, cat, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BMBLikeAPIApi - object-oriented interface
 * @export
 * @class BMBLikeAPIApi
 * @extends {BaseAPI}
 */
export class BMBLikeAPIApi extends BaseAPI {
    /**
     *
     * @summary Like the given content for the current user
     * @param {string} id ID of the content liked
     * @param {string} cat Like category
     * @param {string} [bundle] Optional bundle ID for the content liked
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BMBLikeAPIApi
     */
    public like(id: string, cat: string, bundle?: string, options?: AxiosRequestConfig) {
        return BMBLikeAPIApiFp(this.configuration).like(id, cat, bundle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all all the likes belonging to the given bundle
     * @param {string} bundle Bundle ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BMBLikeAPIApi
     */
    public likesByBundle(bundle: string, options?: AxiosRequestConfig) {
        return BMBLikeAPIApiFp(this.configuration).likesByBundle(bundle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get the likes of a given content
     * @param {string} id ID of the content
     * @param {string} cat Like category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BMBLikeAPIApi
     */
    public likesByContent(id: string, cat: string, options?: AxiosRequestConfig) {
        return BMBLikeAPIApiFp(this.configuration).likesByContent(id, cat, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get the current user\'s likes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BMBLikeAPIApi
     */
    public myLikes(options?: AxiosRequestConfig) {
        return BMBLikeAPIApiFp(this.configuration).myLikes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Unlike the given content for the current user
     * @param {string} id ID of the content unliked
     * @param {string} cat Like category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BMBLikeAPIApi
     */
    public unlike(id: string, cat: string, options?: AxiosRequestConfig) {
        return BMBLikeAPIApiFp(this.configuration).unlike(id, cat, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BMBTimestampAPIApi - axios parameter creator
 * @export
 */
export const BMBTimestampAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timestamps: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bmb/v1/timestamps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} timestampid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimestamp: async (timestampid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timestampid' is not null or undefined
            assertParamExists('updateTimestamp', 'timestampid', timestampid)
            const localVarPath = `/bmb/v1/timestamps/{timestampid}`
                .replace(`{${"timestampid"}}`, encodeURIComponent(String(timestampid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BMBTimestampAPIApi - functional programming interface
 * @export
 */
export const BMBTimestampAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BMBTimestampAPIApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timestamps(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timestamps(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} timestampid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTimestamp(timestampid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTimestamp(timestampid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BMBTimestampAPIApi - factory interface
 * @export
 */
export const BMBTimestampAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BMBTimestampAPIApiFp(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timestamps(options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.timestamps(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} timestampid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimestamp(timestampid: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateTimestamp(timestampid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BMBTimestampAPIApi - object-oriented interface
 * @export
 * @class BMBTimestampAPIApi
 * @extends {BaseAPI}
 */
export class BMBTimestampAPIApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BMBTimestampAPIApi
     */
    public timestamps(options?: AxiosRequestConfig) {
        return BMBTimestampAPIApiFp(this.configuration).timestamps(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} timestampid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BMBTimestampAPIApi
     */
    public updateTimestamp(timestampid: string, options?: AxiosRequestConfig) {
        return BMBTimestampAPIApiFp(this.configuration).updateTimestamp(timestampid, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BetriebsmeldungenAPIApi - axios parameter creator
 * @export
 */
export const BetriebsmeldungenAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        betriebsmeldungen: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/betriebsmeldungen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} msgid
         * @param {number} docid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dokument: async (msgid: number, docid: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'msgid' is not null or undefined
            assertParamExists('dokument', 'msgid', msgid)
            // verify required parameter 'docid' is not null or undefined
            assertParamExists('dokument', 'docid', docid)
            const localVarPath = `/betriebsmeldungen/{msgid}/{docid}`
                .replace(`{${"msgid"}}`, encodeURIComponent(String(msgid)))
                .replace(`{${"docid"}}`, encodeURIComponent(String(docid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BetriebsmeldungenAPIApi - functional programming interface
 * @export
 */
export const BetriebsmeldungenAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BetriebsmeldungenAPIApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async betriebsmeldungen(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Betriebsmeldung>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.betriebsmeldungen(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} msgid
         * @param {number} docid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dokument(msgid: number, docid: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dokument(msgid, docid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BetriebsmeldungenAPIApi - factory interface
 * @export
 */
export const BetriebsmeldungenAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BetriebsmeldungenAPIApiFp(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        betriebsmeldungen(options?: any): AxiosPromise<Array<Betriebsmeldung>> {
            return localVarFp.betriebsmeldungen(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} msgid
         * @param {number} docid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dokument(msgid: number, docid: number, options?: any): AxiosPromise<void> {
            return localVarFp.dokument(msgid, docid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BetriebsmeldungenAPIApi - object-oriented interface
 * @export
 * @class BetriebsmeldungenAPIApi
 * @extends {BaseAPI}
 */
export class BetriebsmeldungenAPIApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BetriebsmeldungenAPIApi
     */
    public betriebsmeldungen(options?: AxiosRequestConfig) {
        return BetriebsmeldungenAPIApiFp(this.configuration).betriebsmeldungen(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {number} msgid
     * @param {number} docid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BetriebsmeldungenAPIApi
     */
    public dokument(msgid: number, docid: number, options?: AxiosRequestConfig) {
        return BetriebsmeldungenAPIApiFp(this.configuration).dokument(msgid, docid, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IntranetAPIApi - axios parameter creator
 * @export
 */
export const IntranetAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me1: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/intranet-api/v1/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntranetAPIApi - functional programming interface
 * @export
 */
export const IntranetAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntranetAPIApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async me1(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.me1(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IntranetAPIApi - factory interface
 * @export
 */
export const IntranetAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntranetAPIApiFp(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me1(options?: any): AxiosPromise<MeDTO> {
            return localVarFp.me1(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntranetAPIApi - object-oriented interface
 * @export
 * @class IntranetAPIApi
 * @extends {BaseAPI}
 */
export class IntranetAPIApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntranetAPIApi
     */
    public me1(options?: AxiosRequestConfig) {
        return IntranetAPIApiFp(this.configuration).me1(options).then((request) => request(this.axios, this.basePath));
    }
}


